import { createFileRoute } from "@tanstack/react-router"
import TrendReportSettings from "@/app/report/trend/settings/page"

export const Route = createFileRoute("/settings/report/trend")({
  component: TrendReportSettings,
})
